import CustomiseCoverPageImagesTabContent from './CustomiseCoverPageImagesTabContent';
import {connect} from 'react-redux';
import PropertyDetailImages from '../lib/PropertyDetailImages';
import resizedDasWebUri, {modes, presetDimensions} from 'components/imaging/ResizedDasWebImage';

const mapStateToProps = (state, ownProps) => {
  const {type} = ownProps;
  const {featureFlags, coverPageImages: {custom = [], large = []} = {custom: [], large: []}} = state;

  const filteredCustom = (imageType) => {
    //todo: need to generate thumbnail on upload of custom images
    //todo: transform custom images in store stripping aws hostname => content.rpdata.com
    return custom
      .filter((item) => item.type === imageType)
      .map(({imageUri}) => ({
        image: imageUri,
        thumbnail: imageUri,
      }));
  };

  const filteredLarge = () => {
    return large.map(({image, thumbnail}) => ({
      image,
      thumbnail: thumbnail || image,
    }));
  };

  const filteredPropertyImages = () => {
    return PropertyDetailImages.list(state.propertyDetail).map(image => ({
      image,
      thumbnail: resizedDasWebUri({uri: image, mode: modes.EXACT, resizeDimensions: presetDimensions.THUMBNAIL}),
    }));
  };

  let images;
  if (type === 'property') {
    images = [
      ...(filteredCustom(type)),
      ...(filteredPropertyImages()),
    ];
  } else {
    images = [
      ...(filteredCustom(type)),
      ...(filteredLarge()),
    ];
  }
  return {
    featureFlags,
    images,
    ...ownProps,
  };
};

export default connect(mapStateToProps)(CustomiseCoverPageImagesTabContent);
